import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, CircleAlert, Link2, Loader2, Unlink } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { PERIOD_LABELS } from "@/lib/boy";

function Row({ ok, title, text, action, testId }) {
  return (
    <div className="flex flex-col gap-3 rounded-lg border p-3 sm:flex-row sm:items-center" data-testid={testId}>
      {ok ? <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-500" /> : <CircleAlert className="h-5 w-5 shrink-0 text-amber-500" />}
      <div className="min-w-0 flex-1"><p className="text-sm font-semibold">{title}</p><p className="text-xs text-muted-foreground">{text}</p></div>
      {action}
    </div>
  );
}

export function PaymentCard({ s, onChange }) {
  const p = s.payment;
  const [busy, setBusy] = useState(false);
  const connect = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/boy/mp/connect", { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  const disconnect = async () => {
    if (!window.confirm("Desconectar o Mercado Pago do recebimento direto?")) return;
    try {
      await api.delete("/boy/mp");
      toast.success("Mercado Pago desconectado");
      onChange();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  const fee = !s.fee_pct ? "Sem taxa da plataforma no momento."
    : p.mode === "direto" ? `Taxa da plataforma: ${s.fee_pct}% por corrida, descontada direto no pagamento quando o Mercado Pago está conectado abaixo. Sem a conexão, entra na fatura ${PERIOD_LABELS[p.period]}.`
      : `Taxa da plataforma: ${s.fee_pct}% por corrida, cobrada em fatura ${PERIOD_LABELS[p.period]} (aba Taxas da plataforma).`;
  return (
    <section className="card-surface space-y-3 p-5" data-testid="boy-payment-card">
      <p className="eyebrow">Recebimento e avisos</p>
      <Row ok={p.own} testId="boy-pay-own" title="Mercado Pago da empresa"
        text={p.own ? "Configurado: os lojistas pagam as corridas direto na sua conta." : "Não configurado. Cole o Access Token em Sistema → Minha empresa → Formas de pagamento."}
        action={!p.own && <Button asChild size="sm" variant="outline"><Link to="/app/sistema/empresa" data-testid="boy-pay-own-config">Configurar</Link></Button>} />
      {p.direct_enabled && (
        <Row ok={p.oauth.connected} testId="boy-pay-oauth" title="Recebimento direto com taxa automática"
          text={p.oauth.connected ? "Conectado: a taxa da plataforma é descontada em cada pagamento, sem fatura." : "Conecte sua conta para a taxa da plataforma ser descontada automaticamente em cada corrida."}
          action={p.oauth.connected
            ? <Button size="sm" variant="ghost" onClick={disconnect} data-testid="boy-pay-oauth-disconnect"><Unlink className="mr-1.5 h-4 w-4" />Desconectar</Button>
            : <Button size="sm" onClick={connect} disabled={busy} data-testid="boy-pay-oauth-connect">{busy ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Link2 className="mr-1.5 h-4 w-4" />}Conectar Mercado Pago</Button>} />
      )}
      <Row ok={s.whatsapp} testId="boy-pay-whatsapp" title="WhatsApp da empresa"
        text={s.whatsapp ? "Conectado: os motoboys recebem as corridas e os lojistas recebem os avisos." : "Desconectado. Conecte em Configurações → WhatsApp Bot para chamar os motoboys."} />
      <p className="text-xs text-muted-foreground" data-testid="boy-pay-fee-text">{fee}</p>
    </section>
  );
}
